import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = () => {
  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <div className="logo-container">
          <img 
            src="https://v-gold.s3.eu-west-2.amazonaws.com/V_Gold.png" 
            alt="VELOX Logo" 
            className="welcome-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen; 